import {useRouteLoaderData} from "react-router";

export type RootLoaderData = {
    frontendProxyBaseUrl: string;
};

export function getFrontendProxyUrl(frontendProxyBaseUrl: string, path: `/${string}`): string {
    return `${frontendProxyBaseUrl.replace(/\/+$/, "")}${path}`;
}

export function useFrontendProxyUrl(path: `/${string}`): string {
    const loaderData = useRouteLoaderData<RootLoaderData>("root");
    if (loaderData === undefined) {
        throw new Error("Root loader data is unavailable.");
    }
    return getFrontendProxyUrl(loaderData.frontendProxyBaseUrl, path);
}
